import React from 'react';
import Waypoint from 'react-waypoint';
import PropTypes from "prop-types";

// WayPointWrapper fix non detectable 0px elements (i.e Firefox Mac)
const WayPointWrapper = ({ onEnter, wrapperHeight }) => {
    return (
        <div style={ { display: 'block', height: wrapperHeight} }>
            <Waypoint onEnter={ onEnter }/>
        </div>
    );
};

WayPointWrapper.propTypes = {
    onEnter: PropTypes.func.isRequired,
    wrapperHeight: PropTypes.string,
};

WayPointWrapper.defaultProps = {
    wrapperHeight: '1px',
};

export default WayPointWrapper;
